module.exports = __webpack_public_path__ + "img/more.05d0535d.svg";